export default function resetGFieldError(fieldElement) {
  fieldElement.classList.remove('gfield_error');
  fieldElement.querySelectorAll('.validation_message').forEach(function(validationMessage) {
    validationMessage.remove();
  });
}